import { render, staticRenderFns } from "./ClassCalendar.vue?vue&type=template&id=6f434084"
import script from "./ClassCalendar.vue?vue&type=script&lang=js"
export * from "./ClassCalendar.vue?vue&type=script&lang=js"
import style0 from "./ClassCalendar.vue?vue&type=style&index=0&id=6f434084&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports